module.exports = __webpack_public_path__ + "img/icon-email.8341ef63.svg";